import _ from 'lodash';
import PropTypes from 'prop-types';

import { quickAdjustmentPropTypes } from 'common/propTypes';
import { QUICK_ADJUSTMENT_ACTIONS, QUICK_ADJUSTMENT_TRIGGERS } from 'v2/common/constants/index';
import { isCaseBasedAction } from '../Intent/OpenLegIntent/QuickAdjustments/Utils';

const propTypes = {
  quickAdjustments: PropTypes.arrayOf(quickAdjustmentPropTypes),
};

const defaultProps = {
  quickAdjustments: [],
};

const renderQuickAdjustmentView = (quickAdjustment) => {
  const {
    trigger, action, targets, delayBy
  } = quickAdjustment;
  const triggerItem = _.find(QUICK_ADJUSTMENT_TRIGGERS, { value: trigger });
  const actionItem = _.find(QUICK_ADJUSTMENT_ACTIONS, { value: action });
  const delayByItem = _.isNumber(delayBy) ? `after ${delayBy} secs` : '';
  const CaseBasedAction = isCaseBasedAction(action)
  const renderLabel = CaseBasedAction ? '' : 'Leg';
  const targetLabels = targets.map((target) => `${CaseBasedAction ? _.toNumber(target) + 1 : target}`).join(' | ');

  return `[On ${triggerItem.shortLabel}, ${actionItem.shortLabel} ${renderLabel}: ${targetLabels} ${delayByItem}]`;
};

const QuickAdjustmentsView = ({ quickAdjustments }) => {
  return quickAdjustments.map(renderQuickAdjustmentView).join('');
};

QuickAdjustmentsView.propTypes = propTypes;
QuickAdjustmentsView.defaultProps = defaultProps;

export default QuickAdjustmentsView;
